import React, { useReducer, useRef, useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import moment from 'moment';
import { cloneDeep, findIndex, get } from 'lodash';
import DiamondListingAction from '../common/DiamondListing/DiamondListingAction';
import Table from '../DiamondList/TableBack';
import { getGridHeight, getState, isArrayEqual } from '../DiamondList';
import { fetchBid, getColumn, TITLE, LISTINGPAGES, isMobile } from '../DiamondList/DiamondListFunctions';
import { getBidType } from '../NewArrivalBidIt';
import Heading from '../common/Heading';
import SelectStone from '../common/DiamondListing/SelectStone';
import { Radio, Dropdown, DatePicker } from 'antd';
import Countdown from '../Offer/Timer';
import IntlMessages from '../../util/IntlMessages';
import { DIAMOND_BID, LOCAL_STORAGE_VAR } from '../../constants/Common';
import BidListMobile from './BidListMobile';
import { getCurrentTime, getNextBidData } from '../../services/util';
import UtilService from '../../services/util';
import NoDataShow from '../common/NoDataShow';
const BIDTAB = {
  LIVE: '1',
  HISTORY: '2',
};

const BidList = (props) => {
  const { location } = props;
  const dispatch = useDispatch();
  const tableRef = useRef();
  const currentType = useRef(location.pathname);
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);
  const [state, setState] = useState(() => cloneDeep(getState()));
  const sortRef = useRef([]);
  const [tab, setTab] = useState(BIDTAB.LIVE);
  const [showError, setShowError] = useState(false);
  const USER_PERMIT = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-userPermissions`);
  const [date, setDate] = useState({
    from: moment().startOf('day').add(-6, 'days'),
    to: moment(),
  });
  const [datePicker, setDatePicker] = useState(false);
  const [currTime, setCurrTime] = useState('');
  const [nextBidData, setNextBidData] = useState({});
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('list');

  useEffect(() => {
    forceUpdate();
  }, [props.commonData.strip, tab]);

  // useEffect(() => {
  //   window.addEventListener('resize', forceUpdate);
  //   fetch();
  //   return () => {
  //     window.removeEventListener('resize', forceUpdate);
  //   };
  // }, [location]);

  useEffect(() => {
    async function setTimers() {
      let time = await getCurrentTime();
      let nextBid = await getNextBidData()
        .then()
        .catch((err) => {
          if (err && err.data && err.data.code === 'E_NOT_FOUND') {
            setState({ ...state, loading: false, data: [] });
          }
        });
      setCurrTime(time.iso);
      setNextBidData(nextBid ? nextBid : []);
      nextBid && localStorage.setItem('sub_types', JSON.stringify(nextBid));
    }
    setTimers();
  }, [state.page, state.limit, date, tab]);

  useEffect(() => {
    fetch();
  }, [date, tab]);

  const setResponse = (res) => {
    setShowError(res?.count === 0);
    let columns = fetchcolumn();
    if (res) {
      let diamondData = res.data,
        defaultChecked = [];
      if (localStorage.getItem(`${LOCAL_STORAGE_VAR}-more`)) {
        defaultChecked = localStorage.getItem(`${LOCAL_STORAGE_VAR}-compare-diamond`)
          ? JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-compare-diamond`))
          : [];
        if (defaultChecked && defaultChecked.length > 0) {
          diamondData &&
            diamondData.map((d) => {
              if (defaultChecked.includes(d.id)) {
                d['isDefaultChecked'] = true;
              }
              return d;
            });
        }
        localStorage.removeItem(`${LOCAL_STORAGE_VAR}-more`);
      }
      setState({
        ...state,
        ...res,
        columns,
        data: diamondData,
        defaultChecked,
        loading: false,
      });
    } else {
      setState({ ...state, loading: false, columns, defaultChecked: [] });
    }
  };

  const handleSort = useCallback(
    (currentSort) => {
      if (currentSort.length !== sortRef.current.length || !isArrayEqual(currentSort, sortRef.current)) {
        sortRef.current = currentSort;
        fetch();
      }
    },
    [sortRef.current],
  );

  const bidEndTime = async () => {
    let nextBid = await getNextBidData()
      .then()
      .catch((err) => {
        if (err && err.data && err.data.code === 'E_NOT_FOUND') {
          setState({ ...state, loading: false, data: [] });
        }
      });
    setNextBidData(nextBid ? nextBid : []);
    getSelection();
  };

  const fetch = useCallback(() => {
    setState({ ...state, data: [] });
    const payload = { ...state, sort: sortRef.current, date };
    if (JSON.stringify(nextBidData) === '[]' && tab !== BIDTAB.LIVE) {
      fetchBid(
        payload,
        undefined,
        undefined,
        tab === BIDTAB.LIVE ? [DIAMOND_BID.STATUS.PENDING] : [DIAMOND_BID.STATUS.WIN, DIAMOND_BID.STATUS.LOSS],
        setResponse,
        tab === BIDTAB.HISTORY,
      );
    } else if (myParam === 'true') {
      return true;
    } else {
      fetchBid(
        payload,
        undefined,
        undefined,
        tab === BIDTAB.LIVE ? [DIAMOND_BID.STATUS.PENDING] : [DIAMOND_BID.STATUS.WIN, DIAMOND_BID.STATUS.LOSS],
        setResponse,
        tab === BIDTAB.HISTORY,
      );
    }
  }, [state.page, state.limit, sortRef.current, state.sum, date, tab, nextBidData]);

  const fetchcolumn = () => {
    let Columns = getColumn();
    let index = findIndex(Columns, { id: 'back' });
    if (!index) index = 1;
    let ctr = Columns.filter((el) => el.id === 'ctPr');
    let amnt = Columns.filter((el) => el.id === 'amt');
    Columns = Columns.filter((el) => el.id !== 'ctPr' && el.id !== 'amt');
    let columns = [
      tab === BIDTAB.HISTORY
        ? {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ cell }) =>
              cell.value === DIAMOND_BID.STATUS.WIN ? (
                <div className="activeStatus">
                  <span>Win</span>
                </div>
              ) : (
                <div className="activeStatus red">
                  <span>Loss</span>
                </div>
              ),
          }
        : null,
      ...Columns.slice(0, index + 1),
      ctr && ctr[0] ? ctr[0] : null,
      amnt && amnt[0] ? amnt[0] : null,
      {
        Header: 'Bid Disc%',
        accessor: 'bidDiscount',
        Cell: ({ cell, row }) => {
          return row.original.isFcCol
            ? '-'
            : cell.value < 0
            ? `-${parseFloat(Math.abs(cell.value)).toFixed(2)}`
            : `+${parseFloat(Math.abs(cell.value)).toFixed(2)}`;
        },
      },
      {
        Header: 'Bid Price/Ct',
        accessor: 'bidPricePerCarat',
        Cell: ({ cell }) => parseFloat(cell.value).toFixed(2),
      },
      {
        Header: 'Bid Amount',
        accessor: 'bidAmount',
        Cell: ({ cell }) => parseFloat(cell.value).toFixed(2),
      },
      ...Columns.slice(index + 1, Columns.length),
    ]
      .filter((el) => el && el)
      .map((col) => ({ ...col, id: col.accessor }));
    return columns;
  };

  const clearAllSelectedRows = useCallback(() => {
    if (isMobile()) {
      dispatch({ type: 'RESET_SELECTED_ROWS' });
    } else {
      let tblRows = document.getElementsByTagName('table')[0].rows;
      for (let row of tblRows) {
        row.classList.remove('selectTr');
      }
      dispatch({ type: 'RESET_SELECTED_ROWS' });
    }
  }, [dispatch]);

  let gridHeight = getGridHeight(
    ['diamondListingAction', 'headerTopMenu', 'selectStonHeader', 'covidStrip', 'HeaderStripBlock'],
    24,
  );
  let user = JSON.parse(window.atob(localStorage.getItem(`${LOCAL_STORAGE_VAR}-user`)));
  let TIME = [
    { name: 'Today', dateFrom: moment().startOf('day'), dateTo: moment() },
    {
      name: 'Yesterday',
      dateFrom: moment().startOf('day').add(-1, 'days'),
      dateTo: moment().endOf('day').add(-1, 'days'),
    },
    {
      name: 'Last 7 Days',
      dateFrom: moment().startOf('day').add(-6, 'days'),
      dateTo: moment(),
    },
    {
      name: 'This Month',
      dateFrom: moment().startOf('month'),
      dateTo: moment(),
    },
    { name: 'This Year', dateFrom: moment().startOf('year'), dateTo: moment() },
    { name: 'All', dateFrom: moment(user.createdAt), dateTo: moment() },
    { name: 'Custom Range', datePicker: true },
  ];

  const getTitle = () => {
    return JSON.stringify(nextBidData) !== '[]' && state.data && state.data.length
      ? TITLE.BID + ' (' + state.count + ')'
      : TITLE.BID + ' (0)';
  };

  const getSelection = () => {
    return tab === BIDTAB.HISTORY ? null : (
      <SelectStone
        profilListing={getBidType() ? 'listingSelected diamondListStone my_bid' : ''}
        sum={state.sum}
        currentType={currentType.current}
      />
    );
  };

  const getAction = () => {
    return tab === BIDTAB.LIVE ? (
      <DiamondListingAction
        {...state}
        {...props}
        nocart
        nowatch
        nonote
        noreminder
        noconfirm
        noquote
        updateBid
        nonocompare={!get(USER_PERMIT, 'COMPARE.view', false)}
        nohold
        nofinalcalc
        noenquiry={!get(USER_PERMIT, 'ENQUIRY.view', false)}
        noshare={
          !get(USER_PERMIT, 'SHARE_VIA_MAIL.view', false) ||
          !get(USER_PERMIT, 'SHARE_VIA_WHATSAPP.view', false) ||
          !get(USER_PERMIT, 'SHARE_VIA_SKYPE.view', false)
        }
        nodownload={!get(USER_PERMIT, 'DOWNLOAD.view', false)}
        noprint={!get(USER_PERMIT, 'PRINT.view', false)}
        currentType={currentType.current}
        nopaginate
        clearAll={clearAllSelectedRows}
        fetch={fetch}
      />
    ) : null;
  };

  const getBidBlock = () => {
    return getBidType() ? (
      <div className="bidEndBlock d-flex align-items-center">
        {JSON.stringify(nextBidData) !== '[]' ? (
          <span className="bidEndLabel">
            <IntlMessages id="app.BidEndIn" /> :
          </span>
        ) : (
          ''
        )}
        {JSON.stringify(nextBidData) !== '[]' ? (
          <Countdown
            currTime={currTime}
            date={
              nextBidData &&
              nextBidData.sub_types &&
              nextBidData.sub_types.currentBidEndDate &&
              moment(nextBidData.sub_types.currentBidEndDate).subtract(moment().utcOffset(), 'minutes')
            }
            bidEndTime={bidEndTime}
          />
        ) : (
          ''
        )}
      </div>
    ) : null;
  };

  const getRadio = () => {
    return (
      <Radio.Group
        value={tab}
        onChange={(e) => {
          setTab(e.target.value);
        }}
      >
        <Radio value={BIDTAB.LIVE}>
          <IntlMessages id="app.LiveBid" />
        </Radio>
        <Radio value={BIDTAB.HISTORY}>
          <span>Bid History</span>
        </Radio>
      </Radio.Group>
    );
  };

  const getDropDown = () => {
    return tab === BIDTAB.HISTORY ? (
      <div
        style={{
          background: 'rgb(255, 255, 255)',
          cursor: 'pointer',
          padding: '4px 9px',
          borderRadius: '5px',
          border: '1px solid #ddd',
          width: '280px',
          color: '#000000',
          marginRight: '5px',
        }}
      >
        <Dropdown
          overlayClassName="mobileSortingDropdown"
          overlay={
            <div className="mobileSortingDropdownList">
              <ul>
                {TIME.map((t) => {
                  return (
                    <li
                      style={{ color: 'inherit', cursor: 'pointer' }}
                      onClick={() => {
                        if (t.datePicker) setDatePicker(true);
                        else
                          setDate({
                            from: t.dateFrom,
                            to: t.dateTo,
                          });
                      }}
                    >
                      {t.name}
                    </li>
                  );
                })}
              </ul>
            </div>
          }
          trigger={['click']}
        >
          {datePicker ? (
            <DatePicker.RangePicker
              open={true}
              onOpenChange={() => setDatePicker(false)}
              onChange={(e) => {
                setDatePicker(false);
                setDate({ from: e[0], to: e[1] });
              }}
              disabledDate={(current) => current && current > moment().endOf('day')}
            />
          ) : (
            <span>
              <img src={require('../../assets/svg/calendar.svg')} width="15px" style={{ marginRight: '10px' }} alt="" />
              <span>
                {date.from.format('ll')} - {date.to.format('ll')}
              </span>
            </span>
          )}
        </Dropdown>
      </div>
    ) : null;
  };

  if (isMobile()) {
    return (
      <BidListMobile
        {...props}
        {...state}
        displayStatus={tab === BIDTAB.HISTORY}
        currentType={currentType.current}
        parent={{
          getTitle,
          getSelection,
          getBidBlock,
          getAction,
          getRadio,
          getDropDown,
        }}
      />
    );
  }
  return (
    <div className="searchResultListWrapper">
      {state.loading && <div className="loading-indicator"></div>}
      <div className="selectStonHeader">
        <div className="d-flex justify-content-between align-items-center width-100 listingTopBlock pos_rel flex-wrap">
          <Heading title={getTitle()} />
          <div className="d-flex">
            <div className="d-flex align-items-center j-content-center mr-10 flex-wrap">
              <div style={{ display: 'block' }}>{getRadio()}</div>
              {getDropDown()}
              <Link className="commonOutline smallButton" to={'/' + LISTINGPAGES.SEARCH_DIAMOND}>
                <span>Go To Bid</span>
              </Link>
            </div>
            {getBidBlock()}
          </div>
          {JSON.stringify(nextBidData) !== '[]' ? getSelection() : ''}
        </div>
      </div>
      <div className="searchInnerResult">
        <div className="searchResultTable" style={{ height: 'calc(100vh - 140px)', overflow: 'auto' }}>
          {state.data && state.data.length ? (
            <Table
              noCheckBox={tab === BIDTAB.HISTORY}
              data={state.data}
              columns={state.columns}
              loading={state.loading}
              ref={tableRef}
              handleSort={handleSort}
              currentType={currentType.current}
              defaultChecked={state.defaultChecked}
            />
          ) : (
            ''
          )}
          {tab === BIDTAB.LIVE && state.data.length === 0 && JSON.stringify(nextBidData) !== '[]' && (
            <NoDataShow message={'No data found.'} />
          )}
          {tab === BIDTAB.HISTORY && state.data.length === 0 && <NoDataShow message={'No data found.'} />}
          {JSON.stringify(nextBidData) === '[]' && showError ? (
            <NoDataShow message={'No Bid submission Found, Hurry UP..!!! Submit your bid before bid ends.'} />
          ) : (
            ''
          )}
          {myParam === 'true' && tab !== BIDTAB.HISTORY && (
            <NoDataShow
              message={'Currently Bid is Inactive, Kindly visit again. You will be notified when Bid is Active.'}
            />
          )}
          {JSON.stringify(nextBidData) !== '[]' && state.data && state.data.length ? getAction() : ''}
        </div>
      </div>
    </div>
  );
};

export default connect((props) => {
  return props;
}, {})(BidList);
